import { Link } from "react-router-dom";
import { ArrowUpRight, CalendarDays, MapPin, Music2 } from "lucide-react";
import { useLang } from "@/lib/i18n";

/**
 * Editorial house promotion for Sunset Salsa. Public sessions and admission
 * are not labeled confirmed until the Event has actual published start_at data.
 * This is an event-series announcement, not an available ticket sale.
 */
export default function LoopSunsetSalsaPromo({ variant = "feature" }) {
  const { lang } = useLang();
  const es = lang === "es";
  const compact = variant === "events";
  return (
    <section aria-label={es?"Sunset Salsa en Paseo Caribe":"Sunset Salsa at Paseo Caribe"}
      className={"group relative isolate overflow-hidden bg-[#201b21] text-[#fcf6ef] " +
        (compact ? "min-h-[230px]" : "min-h-[315px] sm:min-h-[340px]")}>
      <div aria-hidden="true" className="pointer-events-none absolute inset-0 overflow-hidden">
        <div className="absolute -right-12 -top-[140px] h-[390px] w-[390px] rounded-full bg-[radial-gradient(circle,#ffd0a3_0%,#df784a_38%,#aa4350_66%,transparent_70%)] opacity-85 sm:-right-10 sm:-top-[140px]"/>
        <div className="absolute bottom-[-155px] right-[-175px] h-[375px] w-[560px] rotate-[-16deg] rounded-[50%] border-[35px] border-[#e2b084]/20"/>
        <div className="absolute bottom-[-260px] right-[-115px] h-[490px] w-[650px] rotate-[-16deg] rounded-[50%] border-[32px] border-[#e2b084]/15"/>
        <div className="absolute inset-0 bg-gradient-to-r from-[#201b21] via-[#201b21]/85 to-transparent"/>
      </div>
      <div className={"relative z-10 flex h-full flex-col justify-between "+(compact?"p-5 sm:p-7":"p-5 sm:p-9")}>
        <div className="flex flex-wrap items-center justify-between gap-3">
          <p className="font-mono text-[9px] font-black uppercase tracking-[.2em] text-[#f4b18d]">{es?"CULTURA / BAILE / PASEO CARIBE":"CULTURE / DANCE / PASEO CARIBE"}</p>
          <span className="font-mono text-[9px] font-bold uppercase tracking-[.12em] text-white/70">HOSTED BY LOOP EXPERIENCE</span>
        </div>
        <div className={compact?"mt-7":"mt-12"}>
          <div className="mb-2 flex items-center gap-2">
            <Music2 className="h-5 w-5 text-[#f6b08e]" aria-hidden="true"/>
            <span className="font-mono text-[10px] font-bold uppercase tracking-[.16em] text-[#ffc9ad]">{es?"LA ISLA BAILA":"THE ISLAND DANCES"}</span>
          </div>
          <h2 className={"max-w-[650px] font-black uppercase leading-[.88] tracking-[-.065em] "+(compact?"text-[clamp(38px,7vw,63px)]":"text-[clamp(44px,7.8vw,86px)]")}>
            SUNSET<br/>SALSA<span className="text-[#ee875b]">.</span>
          </h2>
          <p className="mt-3 max-w-[52ch] text-[12px] leading-[1.6] text-white/85 sm:text-[14px]">
            {es?"Clases de salsa y baile social en Paseo Caribe, San Juan. Una experiencia de LOOP para encontrarnos a través del ritmo.":"Salsa class and social dancing at Paseo Caribe, San Juan. LOOP brings people together through movement and music."}
          </p>
          <div className="mt-3 flex flex-wrap gap-x-4 gap-y-1 font-mono text-[10px] font-bold uppercase text-white/75">
            <span className="inline-flex items-center gap-1.5"><MapPin className="h-3.5 w-3.5" />PASEO CARIBE · SAN JUAN</span>
            <span className="inline-flex items-center gap-1.5"><CalendarDays className="h-3.5 w-3.5" />{es?"FECHAS POR CONFIRMAR":"DATES TO BE ANNOUNCED"}</span>
          </div>
        </div>
        <div className="mt-5 flex flex-wrap items-center justify-between gap-2 border-t border-white/25 pt-3">
          <span className="font-mono text-[9px] uppercase tracking-[.08em] text-white/65">
            {es?"CONFIRMA TU PRÓXIMA SESIÓN CON LOOP":"CONFIRM THE NEXT SESSION WITH LOOP"}
          </span>
          <Link to="/sunset-salsa-paseo-caribe" className="inline-flex min-h-10 items-center gap-2 bg-[#f7eee5] px-4 text-[11px] font-black uppercase tracking-[.06em] text-[#231e20] transition hover:bg-[#ffc6a9]">
            {es?"Explorar la experiencia":"Explore the series"}<ArrowUpRight className="h-4 w-4"/>
          </Link>
        </div>
      </div>
    </section>
  );
}
